// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-fwwgl-ksdh-index-main_right_content-2xGEk","table":"components-fwwgl-ksdh-index-table-34v5F"};


//////////////////
// WEBPACK FOOTER
// ./components/fwwgl/ksdh/index.css
// module id = 2284
// module chunks = 0